import React from 'react';
import { Field } from 'formik';
import { isNullOrUndefined, validateInput } from '../../../store/storeFunctions';
import { SUBJECT_TYPE } from '../monitoringConstants';
import BbCheckbox from '../../../components/styling/bbCheckbox';
import LinkButton, { BUTTON_TYPE } from '../../common/linkButton';
import MoreButton from '../../layoutItems/moreButton';
import PropTypes from 'prop-types'
import RelationLink from '../../reportSections/relations/relationLink';

const PLACEMENT = "left";

class PortfolioSubjectRow extends React.Component {
    static propTypes = {
        subject: PropTypes.object.isRequired,
        subjectType: PropTypes.number.isRequired,
        index: PropTypes.number.isRequired,
        onCheckedChanged: PropTypes.func,
        onApplyClicked: PropTypes.func,
        onMoveClicked: PropTypes.func,
        onCopyClicked: PropTypes.func,
        onRemoveClicked: PropTypes.func,
        isFirstLevel: PropTypes.bool,
        sharingRole: PropTypes.number
    };

    static defaultProps = {
        isFirstLevel: false,
        sharingRole: 100
    };

    state = {
        isEdited: false,
        label: null
    };

    render() {
        const { subject, subjectType, index, isFirstLevel } = this.props;

        if (subjectType === SUBJECT_TYPE.person) {
            if (isFirstLevel) {
                return (
                    <tr key={index}>
                        <td>
                            {this.renderReference(subject.reference)}
                        </td>
                        <td>
                            <RelationLink entityId={subject.entityId} reports={subject.reports || {}} entityName={subject.name} placement={PLACEMENT} showOnMobile={true} />
                        </td>
                        <td>{subject.birthDateFormated}</td>
                        <td>{subject.warnings && this.renderWarning(subject.warnings)}</td>
                        <td>{subject.label}</td>
                        <td><BbCheckbox id={`${index}-chkDb`} value={subject.entityId != null} disabled={true} onChange={() => false} /></td>
                    </tr>
                );
            }

            return (
                <tr key={index}>
                    <td style={{ verticalAlign: "middle" }}>
                        <BbCheckbox id={`${index}-chk-item`} value={subject.checked || false} onChange={(v) => this.props.onCheckedChanged(subject.id, "checked", v)} />
                    </td>
                    <td>{subject.birthDateFormated}</td>
                    <td>
                        <RelationLink entityId={subject.entityId} reports={subject.reports || {}} entityName={subject.name} placement={PLACEMENT} showOnMobile={true} />
                    </td>
                    <td>{subject.warnings && this.renderWarning(subject.warnings)}</td>
                    <td>{subject.dateAddedFormatted}</td>
                    <td>{this.state.isEdited === true
                        ? <Field type="text" className="input" value={this.state.label} onChange={e => this.setState({ label: e.target.value })} onInput={(e) => validateInput(e)} />
                        : this.state.label
                    }</td>
                    <td><BbCheckbox id={`${index}-chkDb`} value={subject.isRegistered} disabled={true} onChange={() => false} /></td>
                    <td>
                        <div className="portfolio-subject-row-buttons">
                            {this.props.sharingRole < 3 ?
                                this.state.isEdited === true
                                    ? <LinkButton type={BUTTON_TYPE.save} onClick={() => this.onApplyClicked(subject.id, this.state.label)} />
                                    : <LinkButton type={BUTTON_TYPE.edit} onClick={() => this.onEditClicked()} />
                                : null
                            }
                            {this.props.sharingRole < 3 && <LinkButton type={BUTTON_TYPE.remove} onClick={() => this.props.onRemoveClicked(subject.id)} />}
                            <MoreButton mode="rightAligned" contentWidth={150} id={`mb-${index}`}>
                                <div style={{ paddingLeft: "1em", lineHeight: "3em" }}>
                                    {this.props.sharingRole < 3 && <LinkButton type={BUTTON_TYPE.move} onClick={() => this.props.onMoveClicked([subject.id], "MOVE")} showLabelOnMobile={true} />}
                                    {this.props.sharingRole <= 3 && <LinkButton type={BUTTON_TYPE.copy} onClick={() => this.props.onCopyClicked([subject.id], "COPY")} showLabelOnMobile={true} />}
                                </div>
                            </MoreButton>
                        </div>
                    </td>
                </tr>
            );
        }

        if (subjectType === SUBJECT_TYPE.company) {
            if (isFirstLevel) {
                return (
                    <tr key={index}>
                        <td>
                            {this.renderReference(subject.reference)}
                        </td>
                        <td>
                            <RelationLink entityId={subject.entityId} reports={subject.reports || {}} entityName={subject.name} placement={PLACEMENT} showOnMobile={true} />
                        </td>
                        <td>{subject.ico}</td>
                        <td>{subject.warnings && this.renderWarning(subject.warnings)}</td>
                        <td>{subject.label}</td>
                    </tr>
                );
            }

            return (
                <tr key={index}>
                    <td style={{ verticalAlign: "middle" }}>
                        <BbCheckbox id={`${index}-chk-item`} value={subject.checked || false} onChange={(v) => this.props.onCheckedChanged(subject.id, "checked", v)} />
                    </td>
                    <td><div>{subject.ico}</div></td>
                    <td>
                        <RelationLink entityId={subject.entityId} reports={subject.reports || {}} entityName={subject.name} placement={PLACEMENT} showOnMobile={true} />
                    </td>
                    <td>{subject.warnings && this.renderWarning(subject.warnings)}</td>
                    <td>{subject.dateAddedFormatted}</td>
                    <td>{this.state.isEdited === true
                        ? <Field type="text" className="input" value={this.state.label} onChange={e => this.setState({ label: e.target.value })} onInput={(e) => validateInput(e)} />
                        : this.state.label
                    }</td>
                    <td>
                        <div className="portfolio-subject-row-buttons">
                            {this.props.sharingRole < 3 ?
                                this.state.isEdited === true
                                    ? <LinkButton type={BUTTON_TYPE.save} onClick={() => this.onApplyClicked(subject.id, this.state.label)} />
                                    : <LinkButton type={BUTTON_TYPE.edit} onClick={() => this.onEditClicked()} />
                                : null
                            }
                            {this.props.sharingRole < 3 && <LinkButton type={BUTTON_TYPE.remove} onClick={() => this.props.onRemoveClicked(subject.id)} />}
                            <MoreButton mode="rightAligned" contentWidth={150} id={`mb-${index}`}>
                                <div style={{ paddingLeft: "1em", lineHeight: "3em" }}>
                                    {this.props.sharingRole < 3 && <LinkButton type={BUTTON_TYPE.move} onClick={() => this.props.onMoveClicked([subject.id], "MOVE")} showLabelOnMobile={true} />}
                                    {this.props.sharingRole <= 3 && <LinkButton type={BUTTON_TYPE.copy} onClick={() => this.props.onCopyClicked([subject.id], "COPY")} showLabelOnMobile={true} />}
                                </div>
                            </MoreButton>
                        </div>
                    </td>
                </tr>
            );
        }

        if (subjectType === SUBJECT_TYPE.document) {
            if (isFirstLevel) {
                return (
                    <tr key={index}>
                        <td>
                            {this.renderReference(subject.reference)}
                        </td>
                        <td>{subject.ownershipDocumentNumber}</td>
                        <td>{subject.regionName}</td>
                        <td>{subject.districtName}</td>
                        <td>{subject.municipalityName}</td>
                        <td>{subject.cadastreUnitName}</td>
                        <td>{subject.label}</td>
                        <td><BbCheckbox id={`${index}-chkDb`} value={subject.id !== null} disabled={true} onChange={() => false} /></td>
                    </tr>
                );
            }

            return (
                <tr key={index}>
                    <td style={{ verticalAlign: "middle" }}>
                        <BbCheckbox id={`${index}-chk-item`} value={subject.checked || false} onChange={(v) => this.props.onCheckedChanged(subject.id, "checked", v)} />
                    </td>
                    <td>{subject.ownershipDocumentNumber}</td>
                    <td>{subject.regionName}</td>
                    <td>{subject.districtName}</td>
                    <td>{subject.municipalityName}</td>
                    <td>{subject.cadastreUnitName}</td>
                    <td>{subject.dateAddedFormatted}</td>
                    <td>{this.state.isEdited === true
                        ? <Field type="text" className="input" value={this.state.label} onChange={e => this.setState({ label: e.target.value })} onInput={(e) => validateInput(e)} />
                        : this.state.label
                    }</td>
                    <td>
                        <BbCheckbox id={`${index}-chkDb`} value={subject.isRegistered} disabled={true} onChange={() => false} />
                    </td>
                    <td>
                        <div className="portfolio-subject-row-buttons">
                            {this.props.sharingRole < 3 ?
                                this.state.isEdited === true
                                    ? <LinkButton type={BUTTON_TYPE.save} onClick={() => this.onApplyClicked(subject.id, this.state.label)} />
                                    : <LinkButton type={BUTTON_TYPE.edit} onClick={() => this.onEditClicked()} />
                                : null
                            }
                            {this.props.sharingRole < 3 && <LinkButton type={BUTTON_TYPE.remove} onClick={() => this.props.onRemoveClicked(subject.id)} />}
                            <MoreButton mode="rightAligned" contentWidth={150} id={`mb-${index}`}>
                                <div style={{ paddingLeft: "1em", lineHeight: "3em" }}>
                                    {this.props.sharingRole < 3 && <LinkButton type={BUTTON_TYPE.move} onClick={() => this.props.onMoveClicked([subject.id], "MOVE")} showLabelOnMobile={true} />}
                                    {this.props.sharingRole <= 3 && <LinkButton type={BUTTON_TYPE.copy} onClick={() => this.props.onCopyClicked([subject.id], "COPY")} showLabelOnMobile={true} />}
                                </div>
                            </MoreButton>
                        </div>
                    </td>
                </tr>
            );
        }

        return null;
    }

    componentDidMount() {
        this.setState({ label: this.props.subject.label });
    }

    renderWarning = (w) => {
        return (
            <div style={{ display: "flex", whiteSpace: "pre-wrap", flexWrap: "wrap" }}>
                {w.map((x, i) => <span title={x.description} key={i} className={`r-padded rel-warn rel-warn-status-${x.statusId}`}>
                    {x.shortening}
                </span>)}
            </div>
        );
    }

    onApplyClicked = (id, label) => {
        this.props.onApplyClicked(id, label);
        this.setState({ isEdited: false });
    }

    onEditClicked = () => this.setState({ isEdited: true });

    renderReference(reference) {
        return isNullOrUndefined(reference) ? null : <>
            <RelationLink entityId={reference.entityId} reports={reference.reports || {}}
                entityName={reference.name} placement={PLACEMENT} showOnMobile={true}
            />
            {isNullOrUndefined(reference.companyId) || reference.companyId.length === 0 ?
                (isNullOrUndefined(reference.birthDate) ? null : <>({reference.birthDateFormated})</>) :
                <> ({reference.companyId})</>}
        </>
    }
    renderMultiReference(reference) {
        return isNullOrUndefined(reference) ? null : reference.map((r, j) => <span key={j}>
            <RelationLink entityId={r.entityId} reports={r.reports || {}}
                entityName={r.type === 2 ? `${r.name} ${r.surname}` : r.name} placement={PLACEMENT} showOnMobile={true} />
            {r.type === 1
                ? (isNullOrUndefined(r.companyId) ? null : <> ({r.companyId})</>)
                : r.type === 2 ? (isNullOrUndefined(r.birthDate) ? null : <> ({r.birthDateFormated})</>) : null}
            {j < reference.lenght - 1 ? <br /> : null}
        </span>)
    }
}

export default (PortfolioSubjectRow);